import { jsx } from "react/jsx-runtime";
import { IconButton } from "../IconButton/index.js";
const carouselButtonStyleProps = (type)=>'content' === type ? {
        emphasis: 'bold',
        type: 'primary',
        variant: 'outline',
        size: 'md'
    } : {
        emphasis: 'bold',
        type: 'secondary',
        size: 'xs'
    };
const CarouselPrevButton = ({ onClick, buttonClasses, hiddenButtonClasses, iconButtonProps = {}, disabled = false, hidden = false, type = 'image' })=>{
    const { iconName = 'chevron_left', ...restProps } = iconButtonProps;
    const buttonStyleProps = carouselButtonStyleProps(type);
    if (hidden) return /*#__PURE__*/ jsx("div", {
        className: hiddenButtonClasses
    });
    return /*#__PURE__*/ jsx("div", {
        className: buttonClasses,
        children: /*#__PURE__*/ jsx(IconButton, {
            "data-testid": "carousel-prev-button",
            onClick: onClick,
            iconName: iconName,
            shadow: true,
            disabled: disabled,
            ...buttonStyleProps,
            ...restProps
        })
    });
};
const CarouselNextButton = ({ onClick, buttonClasses, iconButtonProps = {}, disabled = false, type = 'image' })=>{
    const { iconName = 'chevron_right', ...restProps } = iconButtonProps;
    const buttonStyleProps = carouselButtonStyleProps(type);
    return /*#__PURE__*/ jsx("div", {
        className: buttonClasses,
        children: /*#__PURE__*/ jsx(IconButton, {
            "data-testid": "carousel-next-button",
            onClick: onClick,
            iconName: iconName,
            shadow: true,
            disabled: disabled,
            ...buttonStyleProps,
            ...restProps
        })
    });
};
export { CarouselNextButton, CarouselPrevButton };
